// スクロール値をCSSカスタムプロパティに設定
const updateScrollValue = () => {
    let winWidth = window.innerWidth;
    const baseEl = document.getElementById('baseWidth');
    let mainWidth = baseEl ? baseEl.clientWidth : winWidth;
    document.documentElement.style.setProperty('--winWidth', winWidth + 'px');
    document.documentElement.style.setProperty('--mainWidth', mainWidth + 'px');
}
// リサイズ時も更新
window.addEventListener('resize', updateScrollValue);

// 初期値設定
updateScrollValue();

// .sankakus[data-sankaku] の span を動的生成
document.querySelectorAll('.sankakus[data-sankaku]').forEach(function (el) {
    var n = parseInt(el.dataset.sankaku, 10);
    for (var i = 0; i < n; i++) {
        el.appendChild(document.createElement('span'));
    }
});

// エピソードスクロールバー サム矢印制御
var episodeContent = document.querySelector('#env-episode .content');
if (episodeContent) {
    var updateEpisodeScroll = function () {
        var atBottom = episodeContent.scrollTop + episodeContent.clientHeight >= episodeContent.scrollHeight - 1;
        episodeContent.classList.toggle('scrolled', episodeContent.scrollTop > 0);
        episodeContent.classList.toggle('at-bottom', atBottom);
    };
    episodeContent.addEventListener('scroll', updateEpisodeScroll);
    updateEpisodeScroll();
}

// インタビュースライド
var iwEl = document.getElementById('iw-splide');
if (iwEl) {
    var iwSplide = new Splide(iwEl, {
        type: 'loop',
        fixedWidth: 375,
        perMove: 1,
        gap: 20,
        arrows: false,
        pagination: false,
        padding: {right: 50},
        breakpoints: {
            1330: {fixedWidth: false, perPage: 3, padding: {right: 40}},
            840: {fixedWidth: false, perPage: 2, gap: 12, padding: {right: 25}},
            480:  {perPage: 2, gap: 10, padding: {right: 16}},
        },
    }).mount();
    var iwCount = document.querySelector('.iw-count');
    if (iwCount) {
        var updateIwCount = function () {
            var cur = String(iwSplide.index + 1).padStart(2, '0');
            var tot = String(iwSplide.length).padStart(2, '0');
            iwCount.textContent = cur + '/' + tot;
        };
        iwSplide.on('moved', updateIwCount);
        updateIwCount();
    }
}

// 福利厚生カードフリップ
document.querySelectorAll('#env-fukuri li:has(.back)').forEach(function (li) {
    li.addEventListener('click', function () {
        li.classList.toggle('is-flipped');
    });
});

// 入社理由ポップアップ
(function () {
    var items = document.querySelectorAll('#env-question .env-reason .reason-item');
    var popup = document.getElementById('env-reason-popup');
    if (!items.length || !popup) return;

    var imgEl  = popup.querySelector('.img img');
    var listEl = popup.querySelector('.points');
    var numEl  = popup.querySelector('.num');
    var openItem = null;

    function open(item) {
        imgEl.src = item.dataset.image;
        imgEl.alt = item.querySelector('.title').textContent;
        var points = JSON.parse(item.dataset.points);
        listEl.innerHTML = points.map(function (p) { return '<li>' + p + '</li>'; }).join('');
        numEl.textContent = item.dataset.count;

        // 測定のため不可視で1フレーム表示
        popup.classList.add('is-measuring');
        popup.classList.remove('is-open');

        requestAnimationFrame(function () {
            var tRect = item.getBoundingClientRect();
            var tCenterX = tRect.left + tRect.width / 2;
            var tCenterY = tRect.top + tRect.height / 2;

            var pRect = popup.getBoundingClientRect();
            var margin = 16;
            var left = (window.innerWidth - pRect.width) / 2;
            left = Math.max(margin, Math.min(left, window.innerWidth - pRect.width - margin));
            var topAbove = tRect.top - pRect.height - 28;
            var topBelow = tRect.bottom + 28;
            var isBelow = topAbove < margin;
            var top = isBelow ? topBelow : topAbove;
            top = Math.max(margin, Math.min(top, window.innerHeight - pRect.height - margin));

            popup.style.left = left + 'px';
            popup.style.top  = top + 'px';

            // 矢印アンカー: トリガーがポップアップ横幅外なら左右辺から、内なら上/下辺から
            var SIDE_THRESHOLD = 24;
            var anchorX, anchorY;
            if (tCenterX < left + SIDE_THRESHOLD) {
                anchorX = 0;
                anchorY = isBelow ? 48 : pRect.height - 48;
            } else if (tCenterX > left + pRect.width - SIDE_THRESHOLD) {
                anchorX = pRect.width;
                anchorY = isBelow ? 48 : pRect.height - 48;
            } else {
                anchorX = tCenterX - left;
                anchorY = isBelow ? 0 : pRect.height;
            }

            // SVG tail はAB辺中点を起点に自然な下-左カーブ（角度+36.2°）を持つ。
            // 上辺出(isBelow)はscaleY(-1)で上下反転。下辺出は素のまま。左右辺出は鏡像反転＋角度補正。
            var SVG_NATURAL_OFFSET = 36.2;
            var dx = tCenterX - (left + anchorX);
            var dy = tCenterY - (top  + anchorY);
            // baseline: -62.9%, -29.4% で AB辺中点がアンカーに重なる。Y方向へ±30%寄せて辺に埋め込む
            var rotation, flipX = 1, flipY = 1, tx, ty;
            // isBelow 時は垂直ミラー状態なので dy を反転して角度を計算する
            var effDy = isBelow ? -dy : dy;
            if (anchorX === 0) {
                // 左辺出
                flipY = isBelow ? -1 : 1;
                rotation = -Math.atan2(dx, effDy) * 180 / Math.PI - SVG_NATURAL_OFFSET;
                tx = '-23.5%';
                ty = isBelow ? '29.4%' : '-29.4%';
            } else if (anchorX === pRect.width) {
                // 右辺出: scaleX反転で視覚的には右へ＝popup内へ
                flipX = -1;
                flipY = isBelow ? -1 : 1;
                rotation = Math.atan2(dx, effDy) * 180 / Math.PI - SVG_NATURAL_OFFSET;
                tx = '-34%';
                ty = isBelow ? '29.4%' : '-29.4%';
            } else {
                // 上/下辺出: h5が画面右半分なら水平反転
                flipX = tCenterX > window.innerWidth / 2 ? -1 : 1;
                flipY = isBelow ? -1 : 1;
                rotation = 0;
                tx = '-62.9%';
                ty = isBelow ? '60.4%' : '-60.4%';
            }
            if (rotation >  150) rotation =  150;
            if (rotation < -150) rotation = -150;

            popup.style.setProperty('--tail-x', anchorX + 'px');
            popup.style.setProperty('--tail-y', anchorY + 'px');
            popup.style.setProperty('--tail-rot', rotation + 'deg');
            popup.style.setProperty('--tail-flip', flipX);
            popup.style.setProperty('--tail-flip-y', flipY);
            popup.style.setProperty('--tail-tx', tx);
            popup.style.setProperty('--tail-ty', ty);
            popup.style.setProperty('--origin-x', anchorX + 'px');
            popup.style.setProperty('--origin-y', anchorY + 'px');

            popup.classList.remove('is-measuring');
            popup.classList.add('is-open');
            popup.setAttribute('aria-hidden', 'false');
            openItem = item;
        });
    }

    function close() {
        if (!openItem) return;
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        openItem = null;
    }

    items.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.stopPropagation();
            if (openItem === item) { close(); return; }
            open(item);
        });
    });

    popup.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', close);
    window.addEventListener('scroll', close, { passive: true });
})();

const targets = document.querySelectorAll('.reveal');

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // 一度出たら監視解除
        }
    });
}, {
    threshold: 0,           // clip-path要素はratio=0のため0で発火
    rootMargin: '0px 0px -10% 0px'  // 少し手前で発火させる
});

targets.forEach(t => observer.observe(t));